import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-icons-close",
  "use": "tc-icons-close-usage",
  "viewBox": "160 160 192 192",
  "content": "<symbol viewBox=\"160 160 192 192\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-icons-close\"><path d=\"m340.2 160-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol